import { Flex } from '@chakra-ui/react';
import React from 'react';
import { AccreditationForm } from './components/AccreditationForm';
import { PageHeader } from './components/PageHeader';
import { UI } from './components/UI';

export const VerifyAccreditationPage: React.FC = () => {
  return (
    <UI>
      <Flex px={[6, 20]} pt={['24px', '56px']} pb={[20, 200]} direction={'column'} gap={10} align="center">
        <PageHeader
          title="Verify Your Accreditation"
          subtitle="Are you an accredited investor? Select all that apply"
          icon="user"
          iconColorScheme="gray"
        />
        <AccreditationForm />
      </Flex>
    </UI>
  );
};
